import { theme } from 'lib';
import styled from 'styled-components';

const Divider = styled.div`
  height: 1px;
  background-color: ${theme.GREY_30};
  margin: ${(props) => props.marg || '0'};
  width: 100%;
`;

export default Divider;
